/* eslint-disable jsdoc/require-returns-description */
import ErrorBoundaryNew from './errorBoundary/ErrorBoundary.jsx'
import ErrorBoundaryDevTrigger from './errorBoundary/ErrorBoundaryDevTrigger.jsx'

/**
 * @param {{ children: React.ReactNode }} props
 * @returns {React.ReactElement}
 */
function ErrorBoundaryContainer({ children }) {
  return (
    <ErrorBoundaryNew>
      <ErrorBoundaryDevTrigger />
      {children}
    </ErrorBoundaryNew>
  )
}

export default ErrorBoundaryContainer
